import { BlogPost } from '../types';
import { platformOverviewPost } from './posts/platform-overview';

// Export all blog posts
export const blogPosts: BlogPost[] = [
    platformOverviewPost
];
